export default "__VITE_ASSET__32e52bb9__"